<template>
  <AddSize />
</template>

<script>
import AddSize from '@/components/product/stockModules/addGurantee.vue'
export default {
  components: {
    AddSize,
  },
}
</script>
